import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
    containerMenuItem: {
        minHeight: 50,
    }
});
